// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from "vuex"
import store from "./vuex/store"
import Toasted from 'vue-toasted';
import VueSweetalert2 from 'vue-sweetalert2';
import BootstrapVue from "bootstrap-vue"
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'sweetalert2/dist/sweetalert2.min.css';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import DynamicSelect from 'vue-dynamic-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.use(DynamicSelect)
require('material-icons')



Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2);
Vue.use(DynamicSelect)
Vue.use(VueGoodTablePlugin);
pdfMake.vfs = pdfFonts.pdfMake.vfs;
Vue.use(Toasted, {
  duration: 2000,
  iconPack: 'material'
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js